import type { enCore } from '../en/core';

export const idCore: Record<keyof typeof enCore, string> = {
  // ---- Product & interfaces ----------------------------------------------------------
  'app.name': 'apis',
  'app.tagline': 'Operasional restoran',
  'iface.kasir.name': 'Kasir',
  'iface.kasir.description': 'Meja, pesanan, tagihan, pembayaran tunai, dan shift kas.',
  'iface.pelayan.name': 'Pelayan',
  'iface.pelayan.description': 'Denah, sesi meja, pencatatan pesanan, dan penyajian.',
  'iface.dapur.name': 'Layar dapur',
  'iface.dapur.description': 'Tiket langsung per stasiun dengan timer dan status satu sentuhan.',
  'iface.backoffice.name': 'Back office',
  'iface.backoffice.description': 'Penjualan, menu, denah, staf, shift kas, dan pengaturan cabang.',
  'iface.stok.name': 'Stok',
  'iface.stok.description': 'Stok tersedia, valuasi, buku mutasi stok, dan saldo awal.',
  'iface.gudang.name': 'Gudang',
  'iface.gudang.description':
    'Penerimaan dan pemeriksaan, penyimpanan, pengambilan, dan pengeluaran ke dapur.',
  'iface.menu.name': 'Menu tamu (QR)',
  'iface.menu.description':
    'Cetak QR meja. Tamu memindainya untuk melihat menu, promo, dan membayar di aplikasi.',

  // ---- Common ------------------------------------------------------------------------
  'common.loading': 'Memuat…',
  'common.retry': 'Coba lagi',
  'common.close': 'Tutup',
  'common.cancel': 'Batal',
  'common.back': 'Kembali',
  'common.save': 'Simpan',
  'common.saving': 'Menyimpan…',
  'common.create': 'Buat',
  'common.creating': 'Membuat…',
  'common.edit': 'Ubah',
  'common.remove': 'Hapus',
  'common.removing': 'Menghapus…',
  'common.confirm': 'Konfirmasi',
  'common.yes': 'Ya',
  'common.no': 'Tidak',
  'common.optional': 'opsional',
  'common.none': 'Tidak ada',
  'common.all': 'Semua',
  'common.table.search': 'Cari di tabel',
  'common.table.reset': 'Atur ulang',
  'common.table.export': 'Ekspor CSV',
  'common.table.exportSelected': 'Ekspor {count} terpilih',
  'common.table.clearSelection': 'Hapus pilihan',
  'common.table.selectAll': 'Pilih semua baris yang tampil',
  'common.table.selectRow': 'Pilih {row}',
  'common.table.sortBy': 'Urutkan menurut {column}',
  'common.table.count': '{count} baris',
  'common.table.shownOf': '{shown} dari {total} baris',
  'common.table.selectedOf': '{selected} dari {total} baris dipilih',
  'common.table.noMatch': 'Tidak ada baris yang cocok dengan pencarian atau filter.',
  'common.active': 'Aktif',
  'common.inactive': 'Nonaktif',
  'common.signOut': 'Keluar',
  'common.signingOut': 'Sedang keluar…',
  'common.account': 'Akun',
  'common.language': 'Bahasa',
  'common.languageName.en': 'English',
  'common.languageName.id': 'Bahasa Indonesia',
  'common.languageShort.en': 'EN',
  'common.languageShort.id': 'ID',
  'common.requestId': 'Referensi: {id}',
  'common.skipToContent': 'Lewati ke konten utama',
  'common.mainNavigation': 'Navigasi utama',
  'common.allInterfaces': 'Semua antarmuka',
  'common.switchInterface': 'Ganti antarmuka',
  'common.minutes': '{count} mnt',
  'common.print': 'Cetak',

  // ---- States ------------------------------------------------------------------------
  'state.laterPhase.badge': 'FASE {phase}',
  'state.laterPhase.title': '{feature} hadir di Fase {phase}',
  'state.laterPhase.description':
    'Antarmuka ini direncanakan untuk Fase {phase} pada peta jalan. Tidak ada yang ditampilkan di sini sampai berjalan dengan data nyata.',

  // ---- Errors ------------------------------------------------------------------------
  'error.generic': 'Permintaan tidak dapat diselesaikan. Coba lagi.',
  'error.network': 'Server tidak dapat dihubungi. Periksa koneksi lalu coba lagi.',
  'error.validation': 'Beberapa isian tidak valid. Periksa lalu coba lagi.',
  'error.conflict': 'Bertentangan dengan data yang sudah ada.',
  'error.versionConflict':
    'Orang lain mengubah data ini pada saat yang sama. Data terbaru sudah dimuat — periksa lalu coba lagi.',
  'error.forbidden': 'Peran Anda tidak mengizinkan tindakan ini.',
  'error.notFound': 'Tidak ditemukan, atau belum tersedia di server ini.',
  'error.unauthenticated': 'Sesi Anda telah berakhir. Silakan masuk lagi.',
  'error.rateLimited': 'Terlalu banyak percobaan. Tunggu sebentar lalu coba lagi.',
  'error.inProgress': 'Percobaan sebelumnya masih diproses. Tunggu sebentar.',
  'error.budgetExceeded': 'Melebihi sisa anggaran.',
  'error.approvalRequired': 'Perlu persetujuan terlebih dahulu.',
  'error.loadFailed': 'Data tidak dapat dimuat.',

  // ---- Realtime ----------------------------------------------------------------------
  'realtime.live': 'Live',
  'realtime.offline': 'Offline',
  'realtime.reconnecting': 'Menyambung ulang…',
  'realtime.connecting': 'Menghubungkan…',
  'realtime.status': 'Pembaruan langsung: {status}',
  'realtime.hint':
    'Layar juga diperbarui berkala; pembaruan langsung hanya membuat perubahan tampil lebih cepat.',

  // ---- Sign in -----------------------------------------------------------------------
  'auth.hero.title': 'Semua meja, tiket, dan tagihan di satu tempat.',
  'auth.hero.subtitle': 'Kasir, dapur, pelayan, dan back office untuk restoran layanan penuh.',
  'auth.signIn.title': 'Masuk',
  'auth.signIn.subtitle': 'Gunakan akun staf Anda.',
  'auth.signIn.email': 'Email',
  'auth.signIn.password': 'Kata sandi',
  'auth.signIn.submit': 'Masuk',
  'auth.signIn.submitting': 'Sedang masuk…',
  'auth.signIn.error.emailRequired': 'Masukkan alamat email Anda.',
  'auth.signIn.error.emailInvalid': 'Masukkan alamat email yang valid.',
  'auth.signIn.error.passwordRequired': 'Masukkan kata sandi Anda.',
  'auth.signIn.error.invalidCredentials': 'Email atau kata sandi salah.',
  'auth.signIn.error.rateLimited':
    'Terlalu banyak percobaan masuk. Tunggu satu menit lalu coba lagi.',
  'auth.signIn.error.generic': 'Gagal masuk. Coba lagi.',

  // ---- Access, tenant & branch -------------------------------------------------------
  'access.denied.title': 'Tidak ada akses ke {app}',
  'access.denied.description':
    'Peran Anda tidak mencakup antarmuka ini di cabang mana pun yang dapat Anda akses. Minta manajer memberikan peran yang sesuai.',
  'access.noTenant.title': 'Tidak ada organisasi aktif',
  'access.noTenant.description':
    'Akun Anda bukan anggota aktif organisasi mana pun. Minta pemilik untuk mengundang Anda.',
  'tenant.label': 'Organisasi',
  'tenant.switch': 'Ganti organisasi',
  'tenant.picker.title': 'Pilih organisasi',
  'tenant.picker.description':
    'Akun Anda terdaftar di beberapa organisasi. Pilih organisasi tempat Anda bekerja.',
  'tenant.switching': 'Mengganti…',
  'tenant.switched': 'Beralih ke {name}.',
  'branch.label': 'Cabang',
  'branch.switch': 'Ganti cabang',
  'branch.picker.title': 'Pilih cabang',
  'branch.picker.description': 'Hanya cabang tempat Anda dapat memakai {app} yang ditampilkan.',
  'branch.option': '{name} ({code})',

  // ---- Launcher ----------------------------------------------------------------------
  'launcher.title': 'Di mana Anda bekerja hari ini?',
  'launcher.subtitle': 'Antarmuka yang diizinkan peran Anda di {branch}.',
  'launcher.subtitleNoBranch': 'Antarmuka yang diizinkan peran Anda.',
  'launcher.open': 'Buka {name}',
  'launcher.later': 'Fase berikutnya',
  'launcher.none':
    'Peran Anda tidak mencakup antarmuka apa pun di cabang ini. Minta manajer memberikan peran.',
  'launcher.signedInAs': 'Masuk sebagai {name}',

  // ---- Statuses ----------------------------------------------------------------------
  'status.table.available': 'Tersedia',
  'status.table.reserved': 'Dipesan',
  'status.table.seated': 'Duduk',
  'status.table.ordering': 'Memesan',
  'status.table.in_service': 'Dilayani',
  'status.table.payment_pending': 'Menunggu bayar',
  'status.table.cleaning': 'Dibersihkan',
  'status.table.out_of_service': 'Tidak dipakai',
  'status.item.draft': 'Draf',
  'status.item.sent': 'Terkirim',
  'status.item.preparing': 'Dimasak',
  'status.item.ready': 'Siap',
  'status.item.served': 'Tersaji',
  'status.item.cancelled': 'Dibatalkan',
  'status.ticket.new': 'Baru',
  'status.ticket.acknowledged': 'Diterima',
  'status.ticket.preparing': 'Dimasak',
  'status.ticket.ready': 'Siap',
  'status.ticket.served': 'Tersaji',
  'status.ticket.cancelled': 'Dibatalkan',
  'status.bill.open': 'Terbuka',
  'status.bill.settled': 'Lunas',
  'status.bill.void': 'Batal',
  'status.shift.open': 'Buka',
  'status.shift.closed': 'Tutup',
  'status.command.pending': 'Mengirim…',
  'status.command.confirmed': 'Tersimpan',
  'status.command.failed': 'Gagal',
};
